//Http
import Request from "../core/httpClient";

const request = new Request();

export const getSubfraccionamientos = async (fraccionamiento) => {

    try {
        const data = { Idsub: fraccionamiento, filter: 1 };

        const response = await request.post("/admin/administracion/get/subfraccionamientos", data);
        const { subfraccionamiento, message, empty, error } = response;

        if (!response || error) return { error: message, subfraccionamientos: [] };

        if (!subfraccionamiento || empty) 
            return { message, subfraccionamientos: [] };

        if (subfraccionamiento.length === 1) {
            localStorage.setItem("subfrac", subfraccionamiento[0].id_subfraccionamiento);

            return { 
                subfraccionamientos: subfraccionamiento,
                subfraccionamiento: subfraccionamiento[0].id_subfraccionamiento
            }
        }
        else return { subfraccionamientos: subfraccionamiento };
        

    } catch (error) {
        console.log(error);
        return { error: "Error al cargar Subfraccionamientos", subfraccionamientos: [] }
    }
};

export const getViviendas = async (idFrac, idSub = 0) => {

    try {
        const data = { idFrac, idSub };

        const response = await request.post("/subfraccionamientos/get/viviendas", data);
        const { subTotalViviendas, message } = response;

        if (subTotalViviendas) return { viviendas: subTotalViviendas };

        else return { viviendas: [], error: message }

    } catch (error) {
        console.log(error);
        return { error, viviendas: [] };
    }
};

export const getMetodosPago = async () => {

    try {
        const result = await request.get("/documentos/get/metodopago/recibo");

        if(result.error) return { error: result.error };

        if (result.empty) return { message: "No se encontraron metodos de pago", metodosPago: [] };

        return { metodosPago: result.metodos };

    } catch (error) {
        console.log(error);
        return { error };
    }
};

export const getParameters = async (id_fraccionamiento = 0) => {
    try {
        
		const data = { id_fraccionamiento };

		const response = await request.post("/facturacion/config", data);
        const { config, empty, error } = response || { error: "ERROR DE CONEXIÓN" };

        if(error || empty) return { error: error || "Error al cargar parametros de facturacion." };

        return { config };

    } catch (error) {
        console.log(error);
        return { error };
    }
}


